var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 59",
    width: 59,
    height: 59,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffbf43}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m31 29.5c34 19.6 18.1 35.5-1.5 1.5-19.6 34-35.5 18.1-1.5-1.5-34-19.6-18.1-35.5 1.5-1.5 19.6-34 35.5-18.1 1.5 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m30.5 30.5c10.2 38-12.2 38-2 0-38 10.2-38-12.2 0-2-10.2-38 12.2-38 2 0 38-10.2 38 12.2 0 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDark);
export default __webpack_public_path__ + "static/media/star-dark.64bd11a4eb8f16ce65b310144e1fb285.svg";
export { ForwardRef as ReactComponent };